// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"393":"36eed8e3","651":"6635728f","756":"6635728f"}[chunkId] + ".chunk.css";
};